// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"b2f07b77","952":"313a11db"}[chunkId] + ".chunk.js";
};